export default "__VITE_ASSET__CuZaPRPn__"